<template>
  <div id="app">
    <nav class="select-menu" :class="{ active: showMenu }">
      <div class="select-btn" @click="showMenu = !showMenu">
        <span>{{ selectedLang }}</span>
      </div>
      <ul class="options">
        <li
          v-for="(lang, index) in languages"
          :key="index"
          class="option"
          :class="{ active: lang.active }"
          @click="handleActiveClick(index)"
        >
          <router-link
:to="{ path: '', query: { lang: `${lang.language}` } }"
            ><span class="option-text">{{ lang.title }}</span></router-link
          >
        </li>
      </ul>
    </nav>
    <Header :strings="strings" />

    <ImageUploader :config="config" :imageUploadDiscList="imageUploadDiscList" :strings="strings"/>
    <Body
      :faqs="faqs"
      :dos="DosContent || ''"
      :donts="DontsContent || ''"
      :intro="intro"
      :disclaimers="disclaimers"
      :guidelineTitle="guidelineTitle"
      :faqsTitle="faqsTitle"
      :DosTitle="DosTitle"
      :DontsTitle="DontsTitle"

    />
    <div class="contact-section" v-html="contactEmail" />
  </div>
</template>

<script>
import Body from './components/Body.vue';
import Header from './components/Header.vue';
import ImageUploader from './components/ImageUploader.vue';
import config from './config';
import Stack from './helpers/contentStackService';

export default {
    name: 'app',
    components: {
        Header,
        Body,
        ImageUploader
    },
    data() {
        return {
            env: config.env,
            config: config.oidc,
            strings: {},
            faqs: [],
            languages: [],
            dos: [],
            donts: [],
            menuActive: false,
            selectedLang: 'Select Language',
            showMenu: false
        };
    },
    watch: {
        currentLanguage: {
            handler(newLang) {
                this.fetchPageStrings(newLang);
                this.fetchFAQs(newLang);
                this.fetchLangs(newLang);
            }
        }
    },
    async created() {
        const lang = 'en'; // Default language is 'en'
        const url = new URL(window.location.href);
        url.searchParams.set('lang', lang);
        this.fetchPageStrings(lang);
        this.fetchFAQs(lang);
        this.fetchLangs(lang);
    },
    computed: {
        currentLanguage() {
            return this.$route.query.lang;
        },
        intro() {
            return this.strings.guidelines_intro;
        },
        disclaimers() {
            return this.strings.disclaimers;
        },
        imageUploadDiscList() {
            return this.strings.image_upload_description_list;
        },
        selectedLangTitle() {
            return this.strings.select_language_title;
        },
        contactEmail() {
            return this.strings.contact_email;
        },
        guidelineTitle() {
            return this.strings.guideline_title;
        },
        faqsTitle() {
            return this.strings.faqs_title;
        },
        DosTitle() {
            return this.strings.dos_title;
        },
        DontsTitle() {
            return this.strings.donts_title;
        },
        DosContent() {
            return this.strings.do_s?.do_s_content || '';
        },
        DontsContent() {
            return this.strings.dont_s?.dont_s_content || '';
        }
    },
    methods: {
        fetchPageStrings(lang) {
            Stack.getEntry('india_opening', lang)
                .then((strings) => {
                    this.strings = strings[0];
                })
                .catch(() => {
                    console.error('Error fetching strings');
                });
        },
        fetchFAQs(lang) {
            Stack.getEntry('india_opening_faq', lang)
                .then((strings) => {
                    this.faqs = strings.reverse();
                })
                .catch(() => {
                    console.error('Error fetching subEntry');
                });
        },
        fetchLangs(lang) {
            Stack.getEntry('india_opening_support_languages', lang)
                .then((langs) => {
                    this.languages = langs.reverse();
                })
                .catch(() => {
                    console.error('Error fetching langs');
                });
        },


        handleActiveClick(index) {
            this.languages.forEach((language, i) => {
                if (i === index) {
                    this.$set(language, 'active', true);
                    this.selectedLang = language.title;
                    this.showMenu = false;
                } else {
                    this.$set(language, 'active', false);
                }
            });
        }
    }
};
</script>

<style lang="scss">
@use "sass:map";
@use "~@nuskin/ns-core-styles/src/scss/colors";
#app {
  font-family: "Inter", Helvetica, Arial, sans-serif;
  margin-top: 0px;
}
.body-wrapper {
  margin-top: 20px;
}
.contact-section {
  max-width: 1440px;
  margin: 0 auto;
  padding: 20px;
  font-family: "inter", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;

  a {
    color: #3783b9;
    text-decoration: none;
    font-weight: 600;

    &:hover {
      text-decoration: underline;
    }
  }

  p {
    font-family: "inter", sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
  }
}
.select-menu {
  max-width: 300px;
  min-width: 140px;
  position: absolute;
  right: 20px;
  top: 10px;
  font-family: Inter;
  .select-btn {
    display: flex;
    background: #fff;
    padding: 10px;

    font-weight: 400;
    align-items: center;
    cursor: pointer;
    justify-content: space-between;
    border: 1px solid #252525;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
    letter-spacing: 0.14px;
    @media screen and (max-width: 480px) {
      font-size: 10px;
    }
  }

  .options {
    position: absolute;
    display: none;
    overflow-y: auto;
    max-height: 295px;
    padding: 10px;
    margin-top: 10px;
    border-radius: 3px;
    background: #fff;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    animation-name: fadeInDown;
    -webkit-animation-name: fadeInDown;
    animation-duration: 0.35s;
    animation-fill-mode: both;
    -webkit-animation-duration: 0.35s;
    -webkit-animation-fill-mode: both;

    .option {
      color: #252525;

      font-family: Inter;
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: 20px;
      letter-spacing: 0.14px;
      display: flex;
      padding: 8px 16px;
      flex-direction: column;
      align-items: flex-start;
      gap: 10px;
      align-self: stretch;
      a {
        text-decoration: none;
        width: 100%;
      }

      &:hover {
        background: map.get(colors.$theme, "accent-color-b");
      }

      .option-text {
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: 20px;
        letter-spacing: 0.14px;
        color: map.get(colors.$theme, "neutral-600");
      }
    }
  }

  &.active {
    .options {
      display: block;
      opacity: 0;
      z-index: 10;
      animation-name: fadeInUp;
      -webkit-animation-name: fadeInUp;
      animation-duration: 0.4s;
      animation-fill-mode: both;
      -webkit-animation-duration: 0.4s;
      -webkit-animation-fill-mode: both;
    }
  }
}

@keyframes fadeInUp {
  from {
    transform: translate3d(0, 30px, 0);
  }
  to {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}

@keyframes fadeInDown {
  from {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
  to {
    transform: translate3d(0, 20px, 0);
    opacity: 0;
  }
}
</style>
